import * as React from 'react';
import { nearLimits } from '@relay-towing/api';
import { NearLimitBanner, Stack } from '@relay-towing/ui';
import { useMember } from '../../hooks/useMember';
import { usePlan, usePlanUsage } from '../../hooks/usePlan';
import { dismiss, isDismissed, monthlyId } from '../../lib/dismissals';
import { links } from '../../lib/links';
import { openExternal } from '../../lib/nativeBridge';

/**
 * The nudge before a plan limit stops anyone: "You've used 41 of 50 calls
 * this month. Essential allows 250." Only for a member who can change the
 * plan (`subscription.view`); nobody else could act on it. Put away, it
 * stays away for that limit until the month turns.
 */
export function NearLimitBanners() {
  const member = useMember();
  const plan = usePlan();
  const usage = usePlanUsage();
  const [, rerender] = React.useReducer((count: number) => count + 1, 0);

  if (!member.can('subscription.view') || !plan.catalogue || !usage.data)
    return null;

  const shown = nearLimits(plan.catalogue, usage.data).filter(
    (near) => !isDismissed(monthlyId(near.limit))
  );
  if (shown.length === 0) return null;

  return (
    <Stack gap={2}>
      {shown.map((near) => (
        <NearLimitBanner
          key={near.limit}
          onUpgrade={near.next ? () => openExternal(links.billing) : undefined}
          onDismiss={() => {
            dismiss(monthlyId(near.limit));
            rerender();
          }}
        >
          {near.message}
        </NearLimitBanner>
      ))}
    </Stack>
  );
}
